import { render, staticRenderFns } from "./FullScreenLayout.vue?vue&type=template&id=2c3c3c8a&scoped=true&"
import script from "./FullScreenLayout.vue?vue&type=script&lang=js&"
export * from "./FullScreenLayout.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenLayout.vue?vue&type=style&index=0&id=2c3c3c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c3c8a",
  null
  
)

export default component.exports